import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import RecipientItem from './RecipientItem';

const RecipientsList = ({ recipients, onSelected }) => (
  <div className="ui segment scrollContent">
    <div className="scroll">
      <div className="ui grid">
        {recipients.map(r => (
          <RecipientItem key={r.id} recipient={r} onSelected={onSelected} />
        ))}
      </div>
    </div>
  </div>
);

RecipientsList.propTypes = {
  recipients: PropTypes.array.isRequired,
  onSelected: PropTypes.func.isRequired,
};

export default pure(RecipientsList);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/RecipientsList.js